import styled from 'styled-components';

const StyledLTRblock = styled.span`
  display: inline-block;
  direction: ltr;
`;

export default StyledLTRblock;
